import { render, staticRenderFns } from "./roomForm.vue?vue&type=template&id=46057354&scoped=true&"
import script from "./roomForm.vue?vue&type=script&lang=js&"
export * from "./roomForm.vue?vue&type=script&lang=js&"
import style0 from "./roomForm.vue?vue&type=style&index=0&id=46057354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46057354",
  null
  
)

export default component.exports